<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center">
            <div class="col ps-5 pt-4 pb-4">
                <h2 class="col pb-2 title">
                    {{ "AUDITLOGS" | translate }}
                </h2>
                <h6 class="col subtitle">{{ "AUDITLOGS_SUBTITLE" | translate }}</h6>
            </div>
            <button class="col-auto add justify-content-center me-5 p-2 ps-3 pe-3" (click)="download()">
                {{ "DOWNLOAD" | translate }}
            </button>
        </div>
        <div class="row g-0 m-0">
            <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
                <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
                <div class="datepicker-container-wrapper position-relative">
                    <div class="button-wrapper">
                        <div class="button">
                            <img alt="Date" src="assets/core/table-button/date.svg" />
                            <div class="button-text" (click)="toggleModal()"
                                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                                    {{ selectedDate }}
                                </ng-container>
                                <ng-template #noDateSelected>
                                    <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                                </ng-template>
                            </div>
                            <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit"
                                src="assets/device/x.svg" (click)="clearDates()" />
                        </div>
                    </div>
                    @if (isDatepickerOpen) {
                    <div class="overlay" (click)="toggleModal()"></div>
                    <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                        [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
                    }
                </div>
                <app-search class="ps-2" placeholder="{{ 'SEARCHBYEMAIL&ACTION' | translate }}"
                    (searchChange)="searchChange($event)">
                </app-search>
            </div>
            <div class="row g-0 m-0 pt-3">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "TIMESTAMP" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "ACTIONTYPE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "ACTIONDETAILS" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_METERNO" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "USER" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{"EMAILADDRESS" | translate}}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of reminderData; let i=index">
                            <td></td>
                            <td>
                                <span>{{ row.hesTime | date: "dd MMM yyyy, h:mm a" }}</span>
                            </td>
                            <td class="wrap-cell">
                                <span [title]="row.controller">{{ row.controller }}</span>
                            </td>
                            <td class="wrap-cell">
                                <span>{{ row.method }}</span>
                            </td>
                            <td>
                                <span (click)="clipboardService.copyToClipboard(row.meterNumber!, $event, i)"
                                    class="copyable">
                                    {{ row.meterNumber }}
                                    <span class="copy-tooltip"
                                        *ngIf="clipboardService.copiedText === i.toString()">{{"COPIED" |
                                        translate}}</span>
                                </span>
                            </td>
                            <td>
                                <span>{{ row.user }}</span><br>
                            </td>
                            <td>
                                <span>{{ row.userEmail }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="container-down">
            <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfReminders" [pageSize]="pageSize"
                [currentPage]="currentPage" (pageChange)="pageChange($event)">
            </app-pagination>
        </div>
    </div>